import LateralMenuSkeleton from "./LateralMenuSkeleton";

/** Envolve a tela (`child`) com a barra superior e o menu lateral. */
export default function LateralMenuContent(props) {
  const { child: Child } = props;

  return (
    <LateralMenuSkeleton>
      <Child {...props} />
    </LateralMenuSkeleton>
  );
}
